import { connectRouter, RouterState } from 'connected-react-router'
import { History } from 'history'
import { combineReducers, AnyAction } from 'redux'
import { busyReducer, BusyState } from './busy'
import { modalReducer, ModalState } from './modal'
import { toastReducer, ToastState } from './toast'
import { Reducer } from 'react'
import { profileReducer, ProfileState } from './profile'
import { ConfigState, configReducer } from './config'
import { channelReducer, ChannelState } from './channel'
import { MessagingState, messagingReducer } from './messaging'

export interface ApplicationState {
	busy: BusyState;
	router: RouterState;
	modal: ModalState;
	toast: ToastState;
	profile: ProfileState;
	config: ConfigState;
	channel: ChannelState;
	messaging: MessagingState;
}

export const createRootReducer = (history: History): Reducer<ApplicationState, AnyAction> =>
	combineReducers<ApplicationState>({
		busy: busyReducer,
		modal: modalReducer,
		toast: toastReducer,
		profile: profileReducer,
		config: configReducer,
		channel: channelReducer,
		messaging: messagingReducer,
		router: connectRouter(history)
	})
